import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getValidateCoordinates } from "./contactAPI";

const initialState = null;

export const fetchCoordinateData = createAsyncThunk(
    'ui/fetchCoordinateData',
    async (obj, thunkAPI) => {
      const { getState } = thunkAPI;
      const response = await getValidateCoordinates(obj);
      return response?.data;
    }
);

const coordSlice = createSlice({
    name: 'coordiantes',
    initialState,
    reducers: {
      resetCoordinateReducer: () => initialState,
    },
    extraReducers: (builder) => {
        builder
          .addCase(fetchCoordinateData.pending, (state) => {
            return {
              ...state,
              status: "loading",
              dataLoaded: false,
              dataFetchFailed: false,
              coordData: initialState
            }
          })
          .addCase(fetchCoordinateData.fulfilled, (state, action) => {
            return {
              ...state,
              status: "idle",
              coordData: action.payload,
              dataFetchFailed: false,
              dataLoaded: true
            }
          })
          .addCase(fetchCoordinateData.rejected, (state) => {
            return {
              ...state,
              dataFetchFailed: true,
              coordData:null,
              status: "idle",
              dataLoaded: true,
            }
          })
        },
});


export const getCoordinateData = (state) => state.coordiantes?.coordData;
export const { resetCoordinateReducer } = coordSlice.actions;
export default coordSlice.reducer;
